import { Chip, Typography, UserGroupGlobeIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import React from 'react';
import { T } from '../../../../../../../../../Translations';

export interface Props {
  children?: React.ReactNode;
}

function AdvancedLeaderProgram({ children }: Props) {
  return (
    <div className="mb-2 flex cursor-pointer">
      <Chip variant="outlined" color="purple" radius="full" className="mr-2">
        <span className="mr-2">
          <UserGroupGlobeIcon color="purple" />
        </span>
        <span>
          <Typography color="purple" variant="caption">
            <T kind="Advanced Leader Program" />
          </Typography>
        </span>
        {children}
      </Chip>
    </div>
  );
}

export default observer(AdvancedLeaderProgram);
